import React,{ useEffect,useState } from 'react';
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Collapse from "@material-ui/core/Collapse";
import { hasChildren } from "./utils";
import SingleLevel from './SingleLevel';
import "./MultiLevel.css";

export const MenuItem = ({ item,setskin_menu }) => {
   const Component = hasChildren(item) ? MultiLevel : SingleLevel;
   return <Component setskin_menu={setskin_menu} item={item} />;
};
export const MultiLevel = ({ item,setskin_menu }) => {
   const [orentation,setOrentation] = useState((window.mob || window.isipad) && window.innerHeight > window.innerWidth ? 0 : 90)

   const { items: children } = item;
   const [open,setOpen] = useState(false);
   const arbuttonName = ((navigator.userAgent.indexOf("iPhone") != -1) || (navigator.userAgent.indexOf('iPad') != -1) || (navigator.userAgent.indexOf('iPod') != -1) || (navigator.userAgent == "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/13.0.1 Safari/605.1.15") || window.detectIpadDevice()) || (navigator.userAgent.match(/Mac/) && navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && (navigator.userAgent.indexOf("iPhone") == -1)) ? 'btnXR-iphone' : 'btnXR';
   useEffect(() => {
      if (item.id === "Exterior") {
         document.getElementById("Exterior").classList.remove('MuiCollapse-hidden');
         document.getElementById("Exterior").classList.add('MuiCollapse-entered');
         document.getElementById("Interior").classList.remove('MuiCollapse-entered');
         document.getElementById("Exterior").previousSibling.classList.add('menuActive');

      }
      document.getElementById("Exterior").previousSibling.classList.add('mainMenuAccordion');
      document.getElementById("Interior").previousSibling.classList.add('mainMenuAccordion');
      document.getElementById("menubtnxr").previousSibling.classList.add('mainMenuAccordion');
      if (document.getElementById("Skins")) {
         document.getElementById("Skins").classList.add('MuiCollapse-entered');
         document.getElementById("Skins").classList.remove('MuiCollapse-hidden');
         document.getElementById("Skins").previousSibling.classList.add('mainMenuAccordion');
         document.getElementById("Skins").previousSibling.classList.add('menuActive');

      }
      window.addEventListener("orientationchange",event => {
         if (window.innerHeight > window.innerWidth) {
            setOrentation(90);
            if (document.getElementById("Skins")) {
               document.getElementById("Skins").classList.add('MuiCollapse-entered');
               document.getElementById("Skins").classList.remove('MuiCollapse-hidden');
               document.getElementById("Skins").previousSibling.classList.add('mainMenuAccordion');
               document.getElementById("Skins").previousSibling.classList.add('menuActive');

            }
         } else {

            setOrentation(0);

         }
      });
   },[]);

   const handleClick = (menuname) => {

      if (!window.menuClick) return;
      window.currentPosition = '';
      window.hidePopUp();
      window.openCloseOnOff = false;
      clearInterval(window.Interval1);
      clearInterval(window.Interval2);
      document.getElementById('openCloseAnimAr').src = "img/Lid_open.svg";
      document.getElementById("footProntNote").style.display = 'none';

      if (!window.mob || (window.isipad && window.innerWidth > window.innerHeight)) {
         console.log("11");
         var exteriorMenu = document.querySelector("#Exterior .MuiList-root");
         var exteriorMenuHeight = exteriorMenu.clientHeight;
         var menuInterior = document.querySelector("#menuInterior .MuiList-root");
         var menuInteriorHeight = menuInterior.clientHeight;
         if (document.querySelector("#menuSkins .MuiList-root") != null) {
            var menuSkins = document.querySelector("#menuSkins .MuiList-root");
            var menuSkinsHeight = menuSkins.clientHeight;
         }

         console.log("22");
         console.log(exteriorMenuHeight,menuInteriorHeight,menuSkinsHeight)

      }

      // if(window.mob || window.isipad &&( window.innerWidth < 818 || window.innerHeight < 818)){
      if (window.mob || (window.isipad && window.innerHeight > window.innerWidth)) {

         const mob_skin_icon = document.getElementsByClassName("mob_skin_icon");
         for (let i = 0; i < mob_skin_icon.length; i++) {
            mob_skin_icon[i].style.display = 'none';
            mob_skin_icon[i].classList.remove('active');
         }
         setskin_menu(false);
         document.getElementById("mob_skin_header_name").style.display = 'inline';
         document.getElementById("skin_type").style.display = 'none';
         document.getElementById("icon_skin").style.height = '90%';
         document.getElementById("skin_type").value = "Skin_Full";
         // window.reset(true);
         window.skin_type = 'skin_full';
         document.getElementById("Full").classList.add('active');
         document.getElementById("Top").classList.remove('active');
         window.scene.groupApplyState('Skin_Full');

      }

      if (menuname === 'Exterior') {
         if (!window.mob || (!window.isipad && window.innerHeight > window.innerWidth)) {
            document.getElementById('Interior').style.height = 0 + "px";
            if (document.getElementById('Skins') != null) {
               document.getElementById('Skins').style.height = 0 + "px";
            }
            document.getElementById('Exterior').style.height = exteriorMenuHeight + "px";
         }
         window.fRotMinLimitVal = 0.20;
         if (document.getElementById("FullDesktop") != null) document.getElementById("FullDesktop").classList.add('active');
         if (document.getElementById("TopDesktop") != null) document.getElementById("TopDesktop").classList.remove('active');
         window.scene.groupApplyState("Screen_fill_ON");
         window.scene.groupApplyState('Skin_off');
         document.getElementById("Exterior").classList.remove('MuiCollapse-hidden');
         document.getElementById("Exterior").classList.add('MuiCollapse-entered');
         document.getElementById("Interior").classList.remove('MuiCollapse-entered');
         document.getElementById("Interior").previousSibling.classList.remove('menuActive');
         document.getElementById("Skins") && document.getElementById("Skins").classList.remove('MuiCollapse-entered');
         document.getElementById("Skins") && document.getElementById("Skins").previousSibling.classList.remove('menuActive');
         document.getElementById("Exterior").previousSibling.classList.add('menuActive');
         if (window.selectedMenu.cameraType != 'exterior') { window.fadeIn(window.reset) }
         else { window.reset() }
         window.GotoPosInTimeNamedValue('Reset_View_F14',function () {
            window.scene.groupApplyState("Screen_fill_ON");

            window.scene.groupApplyState('Ref_ON');
            window.selectedMenu.cameraType = 'exterior';
            setTimeout(window.fadeOut,100)

         });

         const content1 = document.getElementsByClassName("content1");
         for (let i = 0; i < content1.length; i++) {
            content1[i].style.maxHeight = null;
         }

         window.RT_RecordEvent("Exterior","Exterior",window.configProduct.name);
         window.scene.clearRefine();

      } else if (menuname === 'Interior') {
         // menuInterior.style.height = menuInteriorHeight + "px";
         if (!window.mob || (!window.isipad && window.innerHeight > window.innerWidth)) {
            console.log("11111");
            document.getElementById('Exterior').style.height = 0 + "px";
            if (document.getElementById('Skins') != null) {
               document.getElementById('Skins').style.height = 0 + "px";
            }
            document.getElementById('Interior').style.height = menuInteriorHeight + "px";
         }

         window.fRotMinLimitVal = 0.02;
         window.scene.groupApplyState('Skin_off');
         document.getElementById("Interior").classList.remove('MuiCollapse-hidden');
         document.getElementById("Exterior").classList.remove('MuiCollapse-entered');
         document.getElementById("Interior").classList.add('MuiCollapse-entered');
         document.getElementById("Exterior").previousSibling.classList.remove('menuActive');
         document.getElementById("Interior").previousSibling.classList.add('menuActive');
         document.getElementById("Skins") && document.getElementById("Skins").classList.remove('MuiCollapse-entered');
         document.getElementById("Skins") && document.getElementById("Skins").previousSibling.classList.remove('menuActive');
         document.getElementById("openClose").style.opacity = 0.3;
         document.getElementById("openClose").style.pointerEvents = 'none';


         window.animStoped = false;
         window.scene._bDoF = false;
         window.scene._nav._navMinDolly = 25

         if (window.selectedMenu.cameraType != 'interior') { window.fadeIn(window.interiorClick); }
         else { window.interiorClick() }

         window.GotoPosInTimeNamedValue("Render_Cam_F60_Explode",(function () {
            window.selectedMenu.cameraType = 'interior';
            window.selectedMenu.active = 'Render_Cam_F60_Explode';
            // window.scene.setProjectionOffset(-140,0);
            setTimeout(window.fadeOut,500)
         }));
         window.scene._nav._panMax = [10,10];    //[left, bottom];
         window.scene._nav._panMin = [-10,-10];


         const content2 = document.getElementsByClassName("content1");
         for (let i = 0; i < content2.length; i++) {
            content2[i].style.maxHeight = null;
         }
         window.removeSkins();

         window.RT_RecordEvent("Explode","Explode View",window.configProduct.name);
         window.scene.clearRefine();

      } else if (menuname === 'Skins') {
         if (!window.mob || (!window.isipad && window.innerHeight > window.innerWidth)) {
            document.getElementById('Interior').style.height = 0 + "px";
            document.getElementById('Exterior').style.height = 0 + "px";
            // document.getElementById('Skins').style.height = menuSkinsHeight + "px";
            document.getElementById('Skins').style.height = 150 + "px";
         }
         console.log("111");
         document.getElementById("Interior").classList.remove('MuiCollapse-entered');
         document.getElementById("Interior").previousSibling.classList.remove('menuActive');
         document.getElementById("Exterior").classList.remove('MuiCollapse-entered');
         document.getElementById("Exterior").previousSibling.classList.remove('menuActive');
         document.getElementById("Skins").previousSibling.classList.add('menuActive');

         // window.scene.groupApplyState('Skin_Full');
         if (window.selectedMenu.cameraType != 'exterior') { window.fadeIn(window.reset) }
         else { window.reset() }
         window.selectedMenu.cameraType = 'exterior';
         window.GotoPosInTimeNamedValue('Reset_View_F14',function () {
            window.scene.groupApplyState("Screen_fill_ON");
            window.scene.groupApplyState('Ref_ON');
            // window.selectedMenu.cameraType = 'exterior';
            setTimeout(window.fadeOut,100)

         });
         const content2 = document.getElementsByClassName("content1");
         for (let i = 0; i < content2.length; i++) {
            content2[i].style.maxHeight = null;
         }

         window.RT_RecordEvent("Skin","Skin",window.configProduct.name);
         window.scene.clearRefine();

      }
      else {
         document.getElementById("Interior").classList.remove('MuiCollapse-hidden');
         document.getElementById("Interior").previousSibling.classList.remove('menuActive');

         document.getElementById("Exterior").previousSibling.classList.remove('menuActive');



      }
      setTimeout(() => {

         const collection = document.getElementsByClassName("menu");
         for (let i = 0; i < collection.length; i++) {
            collection[i].classList.remove('active');
         }
      },1000);

   };

   return (
      (item.id == 'Skins' && (window.mob || window.isipad) && orentation == 0) ? '' :
         <div className="menu " id={item.id == 'btnXR' ? arbuttonName : 'menu' + item.id} style={item.id == 'btnXR' ? {'display':'none'} : {}}>
            <ListItem button onClick={() => { handleClick(item.id) }}>
               <div className="MuiListItemIcon-root">
                  <img className={`icondiv${item.id}`} src={item.icon} />
               </div>
               <div className="title">
                  <ListItemText primary={item.id == 'Interior' && (window.mob || window.innerHeight > window.innerWidth) ? 'Explode' : item.title} />

               </div>
            </ListItem>
            <Collapse in={open} id={item.id == 'btnXR' ? 'menubtnxr' : item.id} timeout="auto" >
               {/* { item.id=='Skins' && <>
                 <select name="skin_type" id="skin_type" style={ {   marginTop: '8px',fontSize: '16px'}}>
                          
                            <option value="Skin_Full" selected>Skin Full</option>
                            <option value="Skin_Top">Skin Top</option>
                </select></>} */}
               {item.id == 'Skins' && <>
                  <div name="skin_type" id="skin_type" style={{ fontSize: '16px' }}>
                     <button type='button' id="FullDesktop" onClick={window.Skin_Full} className='active'>Full</button>
                     <button type='button' id="TopDesktop" onClick={window.Skin_Top}>Top</button>
                  </div></>}

               <List component="div" >
                  {children.map((child,key) => (
                     <MenuItem key={key} item={child} />
                  ))}
               </List>
            </Collapse>
         </div>
   );
};
//  export default MultiLevel
